<template>
  <div id="antea">
    <div class="columns">
      <div class="column">
        <BarChart class="fijnstof"
      v-if="MeasurementData.fijnstof != undefined"
      :chartData="MeasurementData.fijnstof"
      />
       <BarChart class="ultrafijnstof"
       v-if="MeasurementData.ultrafijnstof != undefined"
      :chartData="MeasurementData.ultrafijnstof"
      />
       <BarChart class="trillingen"
       v-if="MeasurementData.trillingen != undefined"
      :chartData="MeasurementData.trillingen"
      />
       <BarChart class="thies"
       v-if="MeasurementData.thies != undefined"
      :chartData="MeasurementData.thies"
      />
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '../Surveys/BarChart'

export default {
  name: 'Antea',
  components: {
    BarChart
  },
  props: {
    entityId: String,
    highlightDate: Object,
    MeasurementData: Object,
    chartMaxYAxis: Number,
  },
}
</script>
